var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBirthday)?_c('TagBirthday',{attrs:{"variant":_vm.variant}}):_c('div',{staticClass:"discount-offer",class:[
    { '--placeholder': !_vm.offer.discount.value },
    _vm.variant && ("--" + _vm.variant)
  ]},[(_vm.specialType === _vm.SpecialOfferTypeEnum.PRODUCT_AND_SERVICE)?_c('div',{staticClass:"discount-offer__tag"},[_c('span',{staticClass:"discount-offer__value --line"},[_vm._v(_vm._s(_vm.getFormatedDiscount('value', _vm.offer.discount.originalValue || 20)))]),_c('span',{staticClass:"discount-offer__value"},[_vm._v(_vm._s(_vm.getFormatedDiscount(
        'value',
        _vm.calcDiscount(
          _vm.offer.discount.typeName,
          _vm.offer.discount.originalValue || 20,
          _vm.offer.discount.value || 5
        )
      )))])]):_vm._e(),_c('TagSpecialCoin',{staticClass:"discount-offer__tag",attrs:{"variant":_vm.variant}},[(_vm.specialType === _vm.SpecialOfferTypeEnum.PRODUCT_AND_SERVICE)?_c('p',[_vm._v("\n      "+_vm._s(_vm.getFormatedDiscount(
          _vm.offer.discount.typeName,
          _vm.offer.discount.value || 5,
          true
        ))+"\n    ")]):_c('p',[_vm._v("\n      "+_vm._s(_vm.offer.discount.value ? _vm.offer.discount.value : _vm.placeholderTag)+"\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }